var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketIncIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_390_5840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 2.0025V16.005C18 17.1 17.1 18 16.005 18H2.0025C0.9 18 0 17.1075 0 16.005V2.0025C0 0.9 0.9 0 2.0025 0H16.005C17.1 0 18 0.9 18 2.0025Z",
    fill: "#04D6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0022 9.00672C14.0022 9.56172 13.5522 10.0042 13.0047 10.0042H10.0047V13.0042C10.0047 13.5592 9.55471 14.0017 9.00721 14.0017C8.45221 14.0017 8.00971 13.5517 8.00971 13.0042V10.0042H5.00971C4.45471 10.0042 4.01221 9.55422 4.01221 9.00672C4.01221 8.45172 4.46221 8.00922 5.00971 8.00922H8.00971V5.00922C8.00971 4.45422 8.45971 4.01172 9.00721 4.01172C9.56221 4.01172 10.0047 4.46172 10.0047 5.00922V8.00922H13.0047C13.5522 8.00172 14.0022 8.45172 14.0022 9.00672Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_390_5840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketIncIcon);
export default __webpack_public_path__ + "static/media/TicketIncIcon.a3c1a8d22042bc1f71d2e4e622d5cbd9.svg";
export { ForwardRef as ReactComponent };